import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.css'
import '@/assets/css/theme/index.css'
import request from "@/utils/request";
import store from './store';
import '@fortawesome/fontawesome-free/css/all.css'

Vue.config.productionTip = false

Vue.prototype.$request = request
Vue.prototype.$baseUrl = process.env.VUE_APP_BASEURL

Vue.use(ElementUI, {size: "small"})

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')

// 👇 Capacitor原生功能配置
if (window.Capacitor) {
    // 给body添加标识类名，方便CSS控制
    document.body.classList.add('capacitor-android');

    // 状态栏配置
    import('@capacitor/status-bar').then(({ StatusBar }) => {
        // 设置状态栏不覆盖WebView内容（重要！解决顶部遮挡）
        // 关键修改：禁止WebView内容延伸到状态栏下方
        StatusBar.setOverlaysWebView({ overlay: false }); // <--- 把 true 改成 false

        // 设置状态栏文字为深色（适用于浅色背景）
        StatusBar.setStyle({ style: Style.Dark });

        // 当不覆盖时，我们可以给状态栏设置一个明确的背景色
        StatusBar.setBackgroundColor({ color: '#ffffff' }); // <-- 建议添加这一行，设置为你的头部背景色
    }).catch(err => {
        console.log('状态栏插件加载失败:', err);
    });

    // 返回键处理
    import('@capacitor/app').then(({ App }) => {
        App.addListener('backButton', ({ canGoBack }) => {
            // 获取当前路由
            const currentRoute = router.currentRoute.path;

            // 如果在登录页，不允许返回
            if (currentRoute === '/login' || currentRoute === '/login2') {
                return;
            }

            // 如果可以返回上一页
            if (canGoBack) {
                window.history.back();
            } else {
                // 不能返回时，双击退出APP
                if (window.lastBackTime && Date.now() - window.lastBackTime < 2000) {
                    App.exitApp();
                } else {
                    window.lastBackTime = Date.now();
                    ElementUI.Message({
                        message: '再按一次退出Ocean',
                        type: 'info',
                        duration: 2000,
                        showClose: false
                    });
                }
            }
        });
    }).catch(err => {
        console.log('App插件加载失败:', err);
    });

    // 可选：监听APP状态
    import('@capacitor/app').then(({ App }) => {
        // APP从后台恢复
        App.addListener('appStateChange', ({ isActive }) => {
            if (isActive) {
                console.log('APP已激活');
                // 可以在这里刷新数据或检查登录状态
            } else {
                console.log('APP进入后台');
            }
        });

        // APP获取URL（用于分享链接打开APP等场景）
        App.addListener('appUrlOpen', (data) => {
            console.log('APP通过URL打开:', data.url);
        });
    });
}